import { useEffect, useState } from "react";
import { computeSegmentViewAspectRatio } from "../utils/segmentViewAspectRatio";

/**
 * The open-Segment panel's aspect ratio, kept in step with the viewport.
 *
 * F6.9: this was read straight off `window.innerWidth/innerHeight` in the render
 * body with nothing subscribing to `resize`. A window resize does not re-render a
 * React component, so after a resize the value stayed at whatever the viewport was
 * when the pane last happened to render — and the ImageCropper locked the crop to
 * the OLD panel shape, producing a wallpaper that no longer fits the panel it was
 * cropped for. Subscribing here makes the ratio track the panel it describes.
 */
export default function useSegmentViewAspectRatio() {
  const [ratio, setRatio] = useState(() =>
    computeSegmentViewAspectRatio(
      typeof window === "undefined" ? 0 : window.innerWidth,
      typeof window === "undefined" ? 0 : window.innerHeight
    )
  );

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const onResize = () =>
      setRatio(
        computeSegmentViewAspectRatio(window.innerWidth, window.innerHeight)
      );
    onResize(); // re-sync on mount in case the viewport moved while unmounted
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return ratio;
}
